<template>
    <div style="line-height: 0; display: inline-flex;">
        <el-image v-if="url" :src="$util.img(url ? url : '/upload/front/none-image.jpg')" :style="{
            width: width + 'px',
            borderRadius: radius + 'px',
            height: height + 'px',
            display: 'block'
        }" :preview-src-list="[$util.img(url)]" fit="cover">
            <div slot="error" class="image-slot">
                <img :src="$util.img('/upload/front/none-image.jpg')" :style="{
                    width: width + 'px',
                    borderRadius: radius + 'px',
                    height: height + 'px',
                    display: 'block'
                }" />
            </div>
        </el-image>
        <div class="like-image" v-else flex="cross:center main:center" :style="{
            width: width + 'px',
            height: height + 'px'
        }">
            未上传
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        radius: {
            type: [String,Number],
            default: '0'
        },
        width: {
            type: String,
            default: '100'
        },
        height: {
            type: String,
            default: '100'
        }
    }
}
</script>

<style lang="scss" scoped>

    .like-image{
        background: #f0f0f0;
        border-radius: 5px;
        font-size: 13px;
        color: #999;
    }
</style>



// WEBPACK FOOTER //
// src/components/CImage.vue